import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Spin, Typography } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const InviteAccept: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [preview, setPreview] = useState<{ tenant_name: string; email: string; role: string } | null>(null);
  const { user } = useAuth();
  useEffect(() => {
    if (!token) { setError('邀请链接缺少令牌'); setLoading(false); return; }
    api.post('/api/tenants/tenant-invitations/preview', { token })
      .then((res) => setPreview(res.data))
      .catch((err) => setError(err?.response?.data?.detail || '邀请无效或已过期'))
      .finally(() => setLoading(false));
  }, [token]);
  if (loading) return <Spin style={{ display: 'block', margin: '20vh auto' }} />;
  return (
    <Card style={{ maxWidth: 520, margin: '15vh auto' }}>
      {error ? <Alert type="error" message={error} /> : <>
        <Typography.Title level={3}>加入机构</Typography.Title>
        <Typography.Paragraph>您受邀加入 <strong>{preview?.tenant_name}</strong>，角色：{preview?.role}。</Typography.Paragraph>
        <Typography.Paragraph type="secondary">邀请邮箱：{preview?.email}</Typography.Paragraph>
        <Button type="primary" onClick={async () => {
          if (!user) { navigate(`/register?tenant_invitation=${encodeURIComponent(token)}`); return; }
          try {
            await api.post('/api/tenants/tenant-invitations/accept', { token });
            navigate('/');
          } catch (err: any) {
            setError(err?.response?.data?.detail || '接受邀请失败');
          }
        }}>{user ? '接受邀请并加入' : '注册并加入'}</Button>
      </>}
    </Card>
  );
};
export default InviteAccept;
